import React, { useEffect, useState } from 'react'
import classes from './AddQuestion.module.css'
import { Breadcrumb, Col, Form, Row } from 'react-bootstrap'
import Graybg from '../../../../UI/Graybg'
import Card from '../../../../UI/Card/Card'
import Select from '../../../../UI/Select/Select'
import userService from '../../../../app/services/user.service'
import Loader from '../../../../UI/loader/loader'
import { Link, useNavigate } from 'react-router-dom'
import MultiSelectDropdown from '../../../../UI/MultiSelectDropdown/MultiSelectDropdown'
// import CkEditor from '../../../../Components/CkEditor/CkEditor'
import SecBTN from '../../../../UI/SecBTN'
import MyEditor from '../../../../Components/CkEditor/CkEditor'
import FullscreenModal from '../../../../UI/FullscreenModal/FullscreenModal'
import { isEmpty, linkReplaceFn } from '../../../../utils/custom_funtions'
import { toast } from 'react-toastify'
import Toast from '../../../../UI/Toast/Toast'
import RenderText from '../Edit/RenderText/RenderText'
import Input from '../../../../UI/Input/Input'

const AddQuestion = () => {
  const user_id = JSON.parse(localStorage.getItem('user')).data.user.user_id;
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [state, setState] = useState({
    subjectList: [],
    topicList: [],
    subTopicList: [],
    toughnessList: [],
    sub_id: "",
    topic_id: "",
    sub_topic_id: "",
    question_type_id: "",
    toughness_id: "",
    answer_type_id: "",
    applicableFor: [],
    quesTypeList: [],
    ansTypeList: [],
    is_JeeSheet: 0,
    is_NeetSheet: 0,
    is_PYQSheet: 0,
    isFRM: 0,
    is_DPP: 0,
    is_CPS: 0,
    isJT: 0,
    isNT: 0,
    isFT: 0,
    q_text: "",
    q_text_hindi: "",
    p_text: "",
    p_text_hindi: "",
    paragraph_list: [],
    paragraph_id: '',
    p_text: '',
    p_text_hindi: '',
    pageNo: 0,
    m_p_text: '',
    m_p_text_hindi: '',
    matrix_paragraph_id: '',
    edit_paragraph: false,
    para_edited: 0,
    matrix_para_edited: 0,
  });
  //rakesh
  const getSubjectList = () => {
    setIsLoading(true)
    userService.getSubjectList()
      .then(res => {
        setState(prev => {
          return { ...prev, subjectList: res.data.data }
        })
        setIsLoading(false)
      })
      .catch(err => {
        console.log(err);
        setIsLoading(false)
      })
  }
  const getTopicList = (subId) => {
    setIsLoading(true)
    userService.getTopicListBySid(subId)
      .then(res => {
        const topiclist = res.data.data.filter(topic => topic.status == 1 && topic.topic_sequence !== null)
        setState(prev => {
          return { ...prev, topicList: topiclist, subTopicList: [], topic_id: '', sub_topic_id: '', }
        })
        setIsLoading(false)
      })
      .catch(err => {
        console.log(err);
        setState(prev => {
          return { ...prev, topicList: [], subTopicList: [], topic_id: '', sub_topic_id: '' }
        })
        setIsLoading(false)
      })
  }
  const getSubTopicList = (tid) => {
    setIsLoading(true)
    userService.getSubTopicByTid(tid)
      .then(res => {
        const subtopiclist = res.data.data.filter(subtopic => subtopic.status == 1 && subtopic.sub_topic_sequence !== null)
        setState(prev => {
          return { ...prev, subTopicList: subtopiclist }
        })
        setIsLoading(false)
      })
      .catch(err => {
        console.log(err);
        setState(prev => {
          return { ...prev, subTopicList: [] }
        })
        setIsLoading(false)
      })
  }
  const getQuesTypeList = () => {
    setIsLoading(true);
    userService
      .getQuesType()
      .then((res) => {
        setState((prev) => {
          return { ...prev, quesTypeList: res.data.data };
        });
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };
  const getAnsTypeList = () => {
    setIsLoading(true);
    userService
      .getAnsType()
      .then((res) => {
        setState((prev) => {
          return { ...prev, ansTypeList: res.data.data };
        });
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };
  const getToughnessList = () => {
    setIsLoading(true)
    userService.getToughness()
      .then(res => {
        setState(prev => {
          return { ...prev, toughnessList: res.data.data }
        })
        setIsLoading(false)
      })
      .catch(err => {
        console.log(err);
        setIsLoading(false)
      })
  }
  useEffect(() => {
    getSubjectList();
    getToughnessList();
    getQuesTypeList();
    getAnsTypeList();
  }, [])
  const inputHandler = (data) => {
    setState((prev) => {
      return { ...prev, ...data };
    });
  }
  const checkBoxhandler = e => {
    if (e.target.checked) {
      inputHandler({ [e.target.name]: 1 });
      return;
    }
    inputHandler({ [e.target.name]: 0 });
  }
  const onMultiSelect = (selectedList) => {
    setState((prev) => {
      return {
        ...prev,
        applicableFor: selectedList,
      };
    });
  };
  const onMultiRemove = (selectedList) => {
    setState((prev) => {
      return {
        ...prev,
        applicableFor: selectedList,
      };
    });
  };

  const createQuestionHandler = () => {
    const body = {
      sub_id: state.sub_id,
      topic_id: state.topic_id,
      sub_topic_id: state.sub_topic_id,
      toughness_id: state.toughness_id,
      Qtype_id: state.question_type_id,
      answer_type_id: state.answer_type_id,
      jee_sheet: state.is_JeeSheet,
      neet_sheet:state.is_NeetSheet,
      pyq_sheet:state.is_PYQSheet,
      frm: state.isFRM,
      dpp: state.is_DPP,
      cps: state.is_CPS,
      jt: state.isJT,
      nt: state.isNT,
      ft: state.isNT,
      paragraph_id: state.paragraph_id,
      p_text: state.p_text,
      p_text_hindi: state.p_text_hindi,
      matrix_paragraph: state.matrix_paragraph_id,
      m_p_text: state.m_p_text,
      m_p_text_hindi: state.m_p_text_hindi,
      q_text: state.q_text,
      q_text_hindi: state.q_text_hindi,
      para_edited: state.para_edited,
      matrix_para_edited: state.matrix_para_edited,
      Applicable: state.applicableFor.toString(),
      inserted_by: user_id,
    };

    console.log(body)
    userService.createQuesion(body)
      .then(res => {
        console.log("Question Created Successfully !", res.data)
        console.log(res.data)
        navigate(`/editQuestion/edit/${res.data.data}`);
      })
      .catch(err => console.log(err))
  }
  const getParagraphList = (pageNo) => {
    setIsLoading(true)
    const body = {
      sub_topic: state.sub_topic_id,
      toughness: state.toughness_id,
      qid: '',
      start: pageNo,
      selectType: state.question_type_id,
    };
    userService.getParagraphs(body)
      .then(res => {
        setState(prev => {
          return { ...prev, paragraph_list: res.data }
        })
        setIsLoading(false)
        setShowModal(true)
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false)
        if (err.response.status === 404) {
          toast.error('Not found for this combination.')
        } else {
          toast.error('Something went wrong!!')
        }
      })
  }
  const selectParagraph = (data) => {
    setState(prev => {
      return {
        ...prev,
        paragraph_id: data.paragraph_id,
        p_text: data.p_text,
        p_text_hindi: data.p_text_hindi,
        pageNo: 0,
        m_p_text: "",
        m_p_text_hindi: "",
        matrix_paragraph_id: null,
      }
    })
    setShowModal(false);
  }
  const selectMatrixParagraph = (data) => {
    setState(prev => {
      return {
        ...prev,
        paragraph_id: null,
        p_text: "",
        p_text_hindi: "",
        pageNo: 0,
        m_p_text: data.m_p_text,
        m_p_text_hindi: data.m_p_text_hindi,
        matrix_paragraph_id: data.matrix_paragraph_id,
      };
    })
    setShowModal(false);
  }
  const getOverviewData = (searchQid) => {
    userService
      .getOverviewData(searchQid)
      .then((res) => {
        navigate(`/editQuestion/edit/${searchQid}`)
      })
      .catch((err) => {
        console.log(err);
        toast.error(`Data not found for this QID`)
      });
  };

  const qidSubmit = e => {
    e.preventDefault();
    console.log(e.target[0].value)
    getOverviewData(e.target[0].value)
  }

  return (
    <>
      {isLoading && <Loader />}
      <Toast />
      <FullscreenModal show={showModal} onHide={() => setShowModal(false)}>
        <h2 className="mb-3">Paragraph Question</h2>
        {!isEmpty(state.paragraph_list) ? (
          <div className="h-100 d-flex flex-column justify-content-between">
            <div className="table-responsive mb-3">
              <table className="table table-bordered mt-2 mb-0">
                <tbody>
                  {state.question_type_id == 5 &&
                    state.paragraph_list.map((item) => {
                      return (
                        <tr key={item.paragraph_id}>
                          <td>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: linkReplaceFn(item.p_text),
                              }}
                            />
                          </td>
                          <td>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: linkReplaceFn(item.p_text_hindi),
                              }}
                            />
                          </td>
                          <td className="text-center">
                            <SecBTN
                              className="sec-btn1 py-1 px-3"
                              onClick={() => selectParagraph(item)}
                            >
                              <small>Select</small>
                            </SecBTN>
                          </td>
                        </tr>
                      );
                    })}
                  {(state.question_type_id == 9 ||
                    state.question_type_id == 10) &&
                    state.paragraph_list.map((item) => {
                      return (
                        <tr key={item.paragraph_id}>
                          <td>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: linkReplaceFn(item.m_p_text),
                              }}
                            />
                          </td>
                          <td>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: linkReplaceFn(item.m_p_text_hindi),
                              }}
                            />
                          </td>
                          <td className="text-center">
                            <SecBTN
                              className="sec-btn1 py-1 px-3"
                              onClick={() => selectMatrixParagraph(item)}
                            >
                              <small>Select</small>
                            </SecBTN>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-between">
              <SecBTN
                className="sec-btn1"
                disabled={state.pageNo === 0}
                onClick={() => {
                  setState((prev) => {
                    return { ...prev, pageNo: state.pageNo - 10 };
                  });
                  getParagraphList(state.pageNo - 10);
                }}
              >
                Prev
              </SecBTN>
              <SecBTN
                className="sec-btn1"
                disabled={state.paragraph_list.length < 4}
                onClick={() => {
                  setState((prev) => {
                    return { ...prev, pageNo: state.pageNo + 10 };
                  });
                  getParagraphList(state.pageNo + 10);
                }}
              >
                Next
              </SecBTN>
            </div>
          </div>
        ) : (
          "No paragraphes available for this QID."
        )}
      </FullscreenModal>
      {/* <button onClick={() => console.log(state)}>DDDD</button> */}
      <div className="section">
        <h4>Add Question</h4>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/editQuestion">Question</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/editQuestion">Edit Question</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item active>Add Question</Breadcrumb.Item>
        </Breadcrumb>
        <form className="d-flex justify-content-between align-items-center gap-3 mb-4 px-3" onSubmit={qidSubmit} >
          <Input
            style={{ backgroud: "#fff" }}
            type="number"
            placeholder="Search QID"
            name="qid"
          />
          <SecBTN type='submit' className="sec-btn1" style={{ padding: "0.25rem 1rem" }}>
            Search
          </SecBTN>
        </form>
        <Graybg>
          <Card>
            <h6 className="mb-2">Add New Question</h6>
            <Row>
              <Col lg={6} sm={12} className="my-1">
                <Select
                  value={state.sub_id}
                  onChange={(e) => {
                    inputHandler({ sub_id: e.target.value });
                    getTopicList(e.target.value);
                  }}
                >
                  <option value="" disabled>
                    Select Subject
                  </option>
                  {state.subjectList.map((subject) => {
                    return (
                      <option key={subject.sub_id} value={subject.sub_id}>
                        {subject.sub_name}
                      </option>
                    );
                  })}
                </Select>
              </Col>
              <Col lg={6} sm={12} className="my-1">
                <Select
                  value={state.topic_id}
                  onChange={(e) => {
                    inputHandler({ topic_id: e.target.value });
                    getSubTopicList(e.target.value);
                  }}
                >
                  <option value="" disabled>
                    Select Topic
                  </option>
                  {state.topicList.map((topic) => {
                    return (
                      <option key={topic.topic_id} value={topic.topic_id}>
                        {topic.topic_name}
                      </option>
                    );
                  })}
                </Select>
              </Col>
              <Col lg={6} sm={12} className="my-1">
                <Select
                  value={state.sub_topic_id}
                  onChange={(e) => {
                    inputHandler({ sub_topic_id: e.target.value });
                  }}
                >
                  <option value="" disabled>
                    Select Sub-Topic
                  </option>
                  {state.subTopicList.map((subtopic) => {
                    return (
                      <option
                        key={subtopic.sub_topic_id}
                        value={subtopic.sub_topic_id}
                      >
                        {subtopic.Sub_topic_name}
                      </option>
                    );
                  })}
                </Select>
              </Col>
              <Col lg={6} sm={12} className="my-1">
                <Select
                  value={state.question_type_id}
                  onChange={(e) => {
                    inputHandler({ question_type_id: e.target.value, para_edited: 0, matrix_para_edited: 0 });
                  }}
                >
                  <option value="" disabled>
                    Question type
                  </option>
                  {state.quesTypeList.map((quesType) => {
                    return (
                      <option value={quesType.type_id}>{quesType.type}</option>
                    );
                  })}
                </Select>
              </Col>
              <Col lg={4} sm={12} className="my-1">
                <Select
                  value={state.answer_type_id}
                  onChange={(e) => {
                    inputHandler({ answer_type_id: e.target.value });
                  }}
                >
                  <option value="" disabled>
                    Answer type
                  </option>
                  {state.ansTypeList.map((ansType) => {
                    return (
                      <option value={ansType.answer_id}>
                        {ansType.answer_type}
                      </option>
                    );
                  })}
                </Select>
              </Col>
              <Col lg={4} sm={12} className="my-1">
                <Select
                  value={state.toughness_id}
                  onChange={(e) => {
                    inputHandler({ toughness_id: e.target.value });
                  }}
                >
                  <option value="" disabled>
                    Select Toughness
                  </option>
                  {state.toughnessList.map(({ toughness_id, toughness }) => {
                    return (
                      <option key={toughness_id} value={toughness_id}>
                        {toughness}
                      </option>
                    );
                  })}
                </Select>
              </Col>
              <Col lg={4} sm={12} className="my-1">
                {/* <Select>
                  <option selected disabled>
                    Applicable for 
                  </option>
                </Select> */}
                <MultiSelectDropdown
                  isObject={false}
                  options={
                    state.sub_id == 3
                      ? ["JEE Advanced", "JEE-Main"]
                      : state.sub_id == 4
                        ? ["NEET"]
                        : [
                          "JEE Advanced",
                          "JEE-Main",
                          "NEET",
                          "MHT-CET",
                          "PRMO",
                          "NTSE",
                          "IJSO",
                          "Foundation Olympiads",
                          
                        ]
                  }
                  selectedValues={state.applicableFor}
                  onSelect={onMultiSelect}
                  onRemove={onMultiRemove}
                  placeholder="Applicable For"
                />
              </Col>
            </Row>
            <div key={`inline-checkbox`} className="mb-2">
              <Form.Check
                inline
                label="from JEE Sheet?"
                name="is_JeeSheet"
                type="checkbox"
                checked={state.is_JeeSheet == 1 ? true : false}
                onChange={checkBoxhandler}
              />
              <Form.Check
                inline
                label="from NEET Sheet?"
                name="is_NeetSheet"
                type="checkbox"
                checked={state.is_NeetSheet == 1 ? true : false}
                onChange={checkBoxhandler}
              />

              <Form.Check
                inline
                label="from PYQ Sheet?"
                name="is_PYQSheet"
                type="checkbox"
                checked={state.is_PYQSheet == 1 ? true : false}
                onChange={checkBoxhandler}
              />
              <Form.Check
                inline
                label="from FRM?"
                name="isFRM"
                type="checkbox"
                checked={state.isFRM == 1 ? true : false}
                onChange={checkBoxhandler}
              />
              <Form.Check
                inline
                label="from DPP?"
                name="is_DPP"
                type="checkbox"
                checked={state.is_DPP == 1 ? true : false}
                onChange={checkBoxhandler}
              />
              <Form.Check
                inline
                label="from CPS?"
                name="is_CPS"
                type="checkbox"
                checked={state.is_CPS == 1 ? true : false}
                onChange={checkBoxhandler}
              />
              {/*  */}
              <Form.Check
                inline
                label="from JT?"
                name="isJT"
                type="checkbox"
                checked={state.isJT == 1 ? true : false}
                onChange={checkBoxhandler}
              />
              <Form.Check
                inline
                label="from NT?"
                name="isNT"
                type="checkbox"
                checked={state.isNT == 1 ? true : false}
                onChange={checkBoxhandler}
              />
              <Form.Check
                inline
                label="from FT?"
                name="isFT"
                type="checkbox"
                checked={state.isFT == 1 ? true : false}
                onChange={checkBoxhandler}
              />
            </div>
          </Card>
        </Graybg>
        <div className="container-fluid">
          {/*  */}
          {state.question_type_id == 5 && (
            <>
              <div className="d-flex gap-2">
                <SecBTN
                  className="sec-btn1"
                  onClick={() => getParagraphList(state.pageNo)}
                >
                  Existed Paragraph
                </SecBTN>
                <SecBTN
                  className="sec-btn1"
                  onClick={() => {
                    setState((prev) => {
                      return { ...prev, edit_paragraph: !prev.edit_paragraph, para_edited: 1, matrix_para_edited: 0 };
                    });
                  }}
                >
                  Edit
                </SecBTN>
              </div>
              {state.edit_paragraph ? (
                <Row className="mt-3 mb-2">
                  <Col lg={6} md={12} sm={12}>
                    <MyEditor
                      data={state.p_text}
                      handleChange={(data) => {
                        setState((prev) => {
                          return {
                            ...prev,
                            p_text: data,
                          };
                        });
                      }}
                    />
                  </Col>
                  <Col lg={6} md={12} sm={12}>
                    <MyEditor
                      data={state.p_text_hindi}
                      handleChange={(data) => {
                        setState((prev) => {
                          return {
                            ...prev,
                            p_text_hindi: data,
                          };
                        });
                      }}
                    />
                  </Col>
                </Row>
              ) : (
                <>
                  {!isEmpty(state.p_text) ||
                    !isEmpty(state.p_text_hindi) ? (
                    <Row className="mt-3 mb-2">
                      <Col lg={6} md={12} sm={12}>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: linkReplaceFn(state.p_text),
                          }}
                        />
                      </Col>
                      <Col lg={6} md={12} sm={12}>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: linkReplaceFn(state.p_text_hindi),
                          }}
                        />
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                </>
              )}
            </>
          )}
          {(state.question_type_id == 9 || state.question_type_id == 10) && (
            <>
              <div className="d-flex gap-2">
                <SecBTN
                  className="sec-btn1"
                  onClick={() => getParagraphList(state.pageNo)}
                >
                  Existed Paragraph
                </SecBTN>
                <SecBTN
                  className="sec-btn1"
                  onClick={() => {
                    setState((prev) => {
                      return { ...prev, edit_paragraph: !prev.edit_paragraph, para_edited: 0, matrix_para_edited: 1 };
                    });
                  }}
                >
                  Edit
                </SecBTN>
              </div>
              {state.edit_paragraph ? (
                <Row className="mt-3 mb-2">
                  <Col lg={6} md={12} sm={12}>
                    <MyEditor
                      data={state.m_p_text}
                      handleChange={(data) => {
                        setState((prev) => {
                          return {
                            ...prev,
                            m_p_text: data,
                          };
                        });
                      }}
                    />
                  </Col>
                  <Col lg={6} md={12} sm={12}>
                    <MyEditor
                      data={state.m_p_text_hindi}
                      handleChange={(data) => {
                        setState((prev) => {
                          return {
                            ...prev,
                            m_p_text_hindi: data,
                          };
                        });
                      }}
                    />
                  </Col>
                </Row>
              ) : (
                <>
                  {!isEmpty(state.m_p_text) ||
                    !isEmpty(state.m_p_text_hindi) ? (
                    <Row className="mt-3 mb-2">
                      <Col lg={6} md={12} sm={12}>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: linkReplaceFn(state.m_p_text),
                          }}
                        />
                      </Col>
                      <Col lg={6} md={12} sm={12}>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: linkReplaceFn(state.m_p_text_hindi),
                          }}
                        />
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                </>
              )}
            </>
          )}
          {/*  */}
          <div className="my-3">
            <h6>Edit Question here</h6>
            <Row>
              <Col sm={12} md={6} lg={6} className="my-1">
                <MyEditor
                  handleChange={(data) => inputHandler({ q_text: data })}
                />
              </Col>
              <Col sm={12} md={6} lg={6} className="my-1">
                <MyEditor
                  handleChange={(data) => inputHandler({ q_text_hindi: data })}
                />
              </Col>
            </Row>
          </div>
        </div>

        <div className="d-flex justify-content-end gap-3">
          <SecBTN className="sec-btn">Check Duplicate</SecBTN>
          <SecBTN className="sec-btn1" onClick={createQuestionHandler}>
            Add Question
          </SecBTN>
        </div>
        {/* <CkEditor/> */}
      </div>
    </>
  );
}

export default AddQuestion